import type { ReactElement } from 'react'
import { NameCircle } from '~/components/Global/Elements/NameCircle/NameCircle'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { Availability } from '../Availability/Availability'

type ApplicantAvatarProps = {
  applicantId?: number
  fullName: string
  profilePictureUrl?: string | null
  pictureClassName: string
  size: number
  isLoading?: boolean
  isProfilePictureLoading?: boolean
  source: string
}

export const ApplicantAvatar = ({
  applicantId,
  fullName,
  profilePictureUrl,
  pictureClassName,
  size,
  isLoading = false,
  isProfilePictureLoading = false,
  source
}: ApplicantAvatarProps): ReactElement => (
  <>
    {profilePictureUrl && !isLoading && (
      <img
        src={profilePictureUrl}
        className={pictureClassName}
        alt={fullName}
        draggable={false}
      />
    )}
    {!profilePictureUrl && !isLoading && !isProfilePictureLoading && (
      <NameCircle name={fullName} size={size} />
    )}
    {isProfilePictureLoading && <Shimmer height={size} width={size} />}
    {!isLoading && applicantId && (
      <Availability
        applicantId={applicantId}
        variant="embeddedDotBig"
        source={source}
      />
    )}
  </>
)
